import { useEffect, useState } from "react";
// Import Swiper React components
import {
  EffectFade,
  Autoplay,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/scss";
import "swiper/scss/effect-fade";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import { useLocation } from "react-router-dom";

const Certifications = () => {
  useEffect(() => {
    document.title = "Certifications - Deww Botanicals";
  }, []);

  const location = useLocation();
  const currentUrl = location.pathname;

  // Check if the URL contains a specific word
  const shouldShowElement = currentUrl.includes("certifications");

  const [slidesPerView, setSlidesPerView] = useState(3);

  return (
    <>
      {shouldShowElement && (
        <div
          className="container-fluid page-header"
          style={{
            backgroundImage: `url(../assets/images/banner-certificate.jpg)`,
          }}
        >
          <div className="container">
            <h1 className="display-5 mb-3 animated slideInDown">
              Certifications
            </h1>
            <nav aria-label="breadcrumb animated slideInDown">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <span className="text-body">Home</span>
                </li>
                <li
                  className="breadcrumb-item text-dark active"
                  aria-current="page"
                >
                  Certifications
                </li>
              </ol>
            </nav>
          </div>
        </div>
      )}

      <div className="container-fluid bg-theme-light m-0 py-4 py-md-5">
        <div className="container text-primary">
          <div className="section-header text-left mx-auto mb-5 ">
            <h1 className="section-heading text-primary">
              Our Certifications: Committed to Compliance, Quality & Trust only
              this
            </h1>
          </div>

          {shouldShowElement && (
            <>
              <p>
                At Deww Botanicals, we are dedicated to excellence not only in
                the quality of our products but also in upholding the highest
                standards of compliance, transparency, and operational
                integrity. Our certifications demonstrate our commitment to
                responsible business practices, ensuring that our customers
                receive safe, authentic, and traceable products with every
                purchase.
              </p>

              <div className="row">
                <div className="col-12 col-lg-6 col-md-6 px-2 mb-3">
                  <div className="cert-content">
                    <h5>
                       <img src="../assets/images/gmp.jpg" />
                      GMP Certification (Good Manufacturing Practices)</h5>
                    <p>
                      We are in the process of acquiring GMP (Good Manufacturing
                      Practices) certification, which will further standardize
                      our production processes in accordance with global
                      pharmaceutical and cosmetic manufacturing guidelines. This
                      upcoming certification will reinforce our commitment to
                      safety, consistency, and superior product quality.
                    </p>
                  </div>
                </div>
                
                <div className="col-12 col-lg-6 col-md-6 px-2 mb-3">
                  <div className="cert-content">
                    <h5>
                      <img src="../assets/images/fssai.jpg" />
                      FSSAI (Food Safety and Standards Authority of India)
                    </h5>
                    <p>
                      We are licensed by FSSAI, which ensures that all our
                      edible oils and botanical extracts comply with the food
                      safety and hygiene standards set by the Government of
                      India. This certification highlights our commitment to
                      maintaining clean processing environments, accurate
                      labeling, and high-quality ingredients that are safe for
                      consumption and use in wellness formulations.
                    </p>
                  </div>
                </div>

                <div className="col-12 col-lg-6 col-md-6 px-2 mb-3">
                  <div className="cert-content">
                    <h5>
                      <img src="../assets/images/iso.jpg" />
                      ISO 9001:2015 Certified</h5>
                    <p>
                      Our operations are ISO 9001:2015 certified, confirming
                      that our quality management system adheres to
                      international standards. This certification means that
                      every process—from sourcing to packaging—is governed by
                      strict quality control protocols, practices for continuous
                      improvement, and measures to ensure customer satisfaction.
                    </p>
                  </div>
                </div>

                <div className="col-12 col-lg-6 col-md-6 px-2 mb-3">
                  <div className="cert-content">
                    <h5>
                      <img src="../assets/images/iso.jpg" />
                      ISO 22000:2018 Certified</h5>
                    <p>
                      Our operations are ISO 22000:2018 certified, confirming
                      that our quality Food Safety Management Systems (FSMS)
                      adheres to international standards. This certification
                      means that every process—from sourcing to packaging—is
                      governed by strict quality control protocols, practices
                      for continuous improvement, and measures to ensure
                      customer satisfaction.
                    </p>
                  </div>
                </div>

                <div className="col-12 col-lg-6 col-md-6 px-2 mb-3">
                  <div className="cert-content">
                    <h5>
                      <img src="../assets/images/msme.jpg" />
                      MSME (Ministry of Micro, Small & Medium Enterprises)
                    </h5>
                    <p>
                      Deww Botanicals is recognized under the MSME scheme and
                      operates as a certified small-scale enterprise. This
                      status reflects our compliance with Indian industrial
                      standards and underscores our commitment to empowering
                      local communities, generating employment, and driving
                      sustainable economic growth.
                    </p>
                  </div>
                </div>

                <div className="col-12 col-lg-6 col-md-6 px-2 mb-3">
                  <div className="cert-content">
                    <h5>
                       <img src="../assets/images/gst.jpg" />
                      GST Registered (Goods and Services Tax)</h5>
                    <p>
                      We are fully compliant with GST regulations, ensuring
                      transparent and lawful business transactions. Our GST
                      registration allows us to provide seamless invoicing,
                      claim input tax credits, and facilitate smooth B2B
                      dealings across India.
                    </p>
                  </div>
                </div>

              </div>

              <p>
                At Deww Botanicals, you choose a brand that values compliance,
                credibility, and customer confidence. Every certification we
                hold is a testament to our pursuit of excellence, ensuring that
                your trust in our brand is always well-placed.
              </p>
            </>
          )}

          <div className="row g-4 d-none d-sm-flex">
            <div
              className={
                shouldShowElement
                  ? "col-6 col-lg-4 col-md-6"
                  : "col-6 col-lg-4 col-md-6"
              }
            >
              <div className="text-center h-100 text-primary category-item certificate-item">
                <img
                  className="rounded img-fluid mb-2"
                  src="../assets/images/fssai_deww.jpg"
                  alt=""
                />
                <h6 className="mb-1 text-primary">FSSAI</h6>
              </div>
            </div>
            <div
              className={
                shouldShowElement
                  ? "col-6 col-lg-4 col-md-6"
                  : "col-6 col-lg-4 col-md-6"
              }
              data-wow-delay="0.3s"
            >
              <div className="text-center h-100 text-primary category-item certificate-item">
                <img
                  className="rounded img-fluid mb-2"
                  src="../assets/images/msme_deww.jpg"
                  alt=""
                />
                <h6 className="mb-1 text-primary">MSME</h6>
              </div>
            </div>
            <div
              className={
                shouldShowElement
                  ? "col-6 col-lg-4 col-md-6"
                  : "col-6 col-lg-4 col-md-6"
              }
              data-wow-delay="0.5s"
            >
              <div className="text-center h-100 text-primary category-item certificate-item">
                <img
                  className="rounded img-fluid mb-2"
                  src="../assets/images/iso_deww.jpg"
                  alt=""
                />
                <h6 className="mb-1 text-primary">ISO 9001</h6>
              </div>
            </div>
            <div
              className={
                shouldShowElement
                  ? "col-6 col-lg-4 col-md-6"
                  : "col-6 col-lg-4 col-md-6"
              }
              data-wow-delay="0.5s"
            >
              <div className="text-center h-100 text-primary category-item certificate-item">
                <img
                  className="rounded img-fluid mb-2"
                  src="../assets/images/iso_22000_deww.jpg"
                  alt=""
                />
                <h6 className="mb-1 text-primary">ISO 22000</h6>
              </div>
            </div>
            <div
              className={
                shouldShowElement
                  ? "col-6 col-lg-4 col-md-6"
                  : "col-6 col-lg-4 col-md-6"
              }
              data-wow-delay="0.5s"
            >
              <div className="text-center h-100 text-primary category-item certificate-item">
                <img
                  className="rounded img-fluid mb-2"
                  src="../assets/images/gmp_deww.jpg"
                  alt=""
                />
                <h6 className="mb-1 text-primary">GMP</h6>
              </div>
            </div>
            <div
              className={
                shouldShowElement
                  ? "col-6 col-lg-4 col-md-6"
                  : "col-6 col-lg-4 col-md-6"
              }
              data-wow-delay="0.5s"
            >
              <div className="text-center h-100 text-primary category-item certificate-item">
                <img
                  className="rounded img-fluid mb-2"
                  src="../assets/images/gst_deww.jpg"
                  alt=""
                />
                <h6 className="mb-1 text-primary">GST</h6>
              </div>
            </div>
          </div>

          <div className="row g-4 d-sm-none mx-0">
            <Swiper
              modules={[EffectFade, Autoplay, Pagination, Scrollbar, A11y]}
              spaceBetween={20}
              slidesPerView={2}
              breakpoints={{
                540: { slidesPerView: 2 },
                768: { slidesPerView: 5 },
                1024: { slidesPerView: 6 },
              }}
              style={{ display: "flex" }}
              loop
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              onSwiper={(swiper) => console.log(swiper)}
            >
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item certificate-item">
                  <img
                    className="rounded img-fluid mb-2"
                    src="../assets/images/fssai_deww.jpg"
                    alt=""
                  />
                  <h6 className="mb-1 text-primary">FSSAI</h6>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item certificate-item">
                  <img
                    className="rounded img-fluid mb-2"
                    src="../assets/images/msme_deww.jpg"
                    alt=""
                  />
                  <h6 className="mb-1 text-primary">MSME</h6>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item certificate-item">
                  <img
                    className="rounded img-fluid mb-2"
                    src="../assets/images/iso_deww.jpg"
                    alt=""
                  />
                  <h6 className="mb-1 text-primary">ISO 9001</h6>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item certificate-item">
                  <img
                    className="rounded img-fluid mb-2"
                    src="../assets/images/iso_22000_deww.jpg"
                    alt=""
                  />
                  <h6 className="mb-1 text-primary">ISO 22000</h6>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item certificate-item">
                  <img
                    className="rounded img-fluid mb-2"
                    src="../assets/images/gmp_deww.jpg"
                    alt=""
                  />
                  <h6 className="mb-1 text-primary">GMP</h6>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item certificate-item">
                  <img
                    className="rounded img-fluid mb-2"
                    src="../assets/images/gst_deww.jpg"
                    alt=""
                  />
                  <h6 className="mb-1 text-primary">GST</h6>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>

        <div className="container text-primary mt-3">
          <div className="section-header text-left mx-auto mb-2">
            <h1 className="section-heading text-primary">Yes we are</h1>
          </div>
          <div className="row g-4 mx-0">
            <Swiper
              modules={[EffectFade, Autoplay, Pagination, Scrollbar, A11y]}
              spaceBetween={20}
              slidesPerView={slidesPerView}
              breakpoints={{
                540: { slidesPerView: 3 },
                768: { slidesPerView: 5 },
                1024: { slidesPerView: 6 },
              }}
              style={{ display: "flex" }}
              loop
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              onSwiper={(swiper) => console.log(swiper)}
            >
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item">
                  <img
                    className="rounded img-fluid mb-2"
                    src="../assets/images/cruelty-free.jpg"
                    alt=""
                  />
                  <h6 className="mb-1 text-primary">Cruelty Free</h6>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item">
                  <img
                    className="rounded img-fluid mb-2"
                    src="../assets/images/gmo.jpg"
                    alt=""
                  />
                  <h6 className="mb-1 text-primary">Non GMO</h6>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item">
                  <img
                    className="rounded img-fluid mb-2"
                    src="../assets/images/alcohol-free.jpg"
                    alt=""
                  />
                  <h6 className="mb-1 text-primary">Non Alcoholic</h6>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item">
                  <img
                    className="rounded img-fluid mb-2"
                    src="../assets/images/vegan.jpg"
                    alt=""
                  />
                  <h6 className="mb-1 text-primary">Vegan</h6>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item">
                  <img
                    className="rounded img-fluid mb-2"
                    src="../assets/images/herbal.jpg"
                    alt=""
                  />
                  <h6 className="mb-1 text-primary">Herbal</h6>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item">
                  <img
                    className="rounded img-fluid mb-2"
                    src="../assets/images/ecofriendly.jpg"
                    alt=""
                  />
                  <h6 className="mb-1 text-primary">Eco Friendly</h6>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item">
                  <img
                    className="rounded img-fluid mb-2"
                    src="../assets/images/sustainable.jpg"
                    alt=""
                  />
                  <h6 className="mb-1 text-primary">Sustainable</h6>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </>
  );
};

export default Certifications;
